import getFirstDayOfWeek from './getFirstDayOfWeek';

export default function isLastDayOfWeek(day) {
  return day.weekday === (getFirstDayOfWeek() + 6) % 7;
}
